<template>
  <div class="pdt-20px">
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('editCommandeAchatBailleur.infoGenerales.title')}}</p>
      </header>
      <info-generales :commande-achat-bailleur="commandeAchatBailleur"></info-generales>
    </div>
    <div class="section-details card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('editCommandeAchatBailleur.bailleur.title')}}
        </p>
      </header>
      <info-bailleur :bailleur="commandeAchatBailleur.intervenants[0]"></info-bailleur>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('editCommandeAchatBailleur.infoProduit.title')}}</p>
      </header>
      <div class="pd-20px">
        <lignes-vente ref="ligneVente"
                      :dcf="commandeAchatBailleur"
                      :sens="commandeAchatBailleur.sens"
                      :modulePresseActive="modulePresseActive"
                      :periodeTotalCalculTlpeAuto="false"
                      :filtrerProduitParSociete="false"
                      :activationYield="false"
                      :regimesTva="regimesTva"
                      :is-credit-note="true"
                      :isAvoirLibre="false"
                      :error="false"
                      :lignes-commande-to-display="getLignesCommandeToDisplay()"
                      @reloadTotalHt="calcul"
        >
        </lignes-vente>
        <div class="columns level-right mgt-40px mgb-20px">
          <div class="commandes__total">
            <div class="commandes__total-ligne">
              <div>
              <span>
                {{ $t('ajoutDevis.informations.totalHt')}}
              </span>
                <span class="has-text-weight-semibold ellipsis">
                {{ commandeAchatBailleur.montantHt | formatDevise }}
              </span>
              </div>
            </div>
            <div class="commandes__total-ligne">
              <div>
              <span>
                  {{ $t('ajoutDevis.informations.totalTva')}}
              </span>
                <span class="ellipsis">
                {{ commandeAchatBailleur.montantTva | formatDevise }}
              </span>
              </div>
            </div>
            <div class="commandes__total-ligne">
              <div>
              <span>
                {{ $t('ajoutDevis.informations.totalTtc')}}
              </span>
                <span class="has-text-weight-semibold ellipsis">
                {{ commandeAchatBailleur.montantTtc | formatDevise }}
              </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('editCommandeAchatBailleur.infoCommentaire.title')}}</p>
      </header>
      <info-commentaires :commande-achat-bailleur="commandeAchatBailleur"></info-commentaires>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('piecesJointes.attachments')}}</p>
      </header>
      <div class="card-content">
        <pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import regleFacturationInitialize from '@/services/devisCommandes/regleFacturationInitialize';
import {
  PARAMETRES_INTERNE_KEYS,
  PARAMETRES_KEYS,
} from '@/store/modules/parametres-mutation-type';
import infoGenerales from '@/components/baux/commandeAchat/addEdit/infoGenerales';
import piecesJointes from '@/components/general/piecesJointes';
import infoBailleur from '@/components/baux/commandeAchat/addEdit/infoBailleur';
import infoCommentaires from '@/components/baux/commandeAchat/addEdit/infoCommentaires';
import lignesVente from '@/components/bodac/dcf/addEditDcf/lignesVente';
import { PERSONNALISE } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    lignesVente,
    infoGenerales,
    infoBailleur,
    infoCommentaires,
    piecesJointes,
  },
  props: {
    commandeAchatBailleur: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      allOpen: true,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    regimesTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getLignesCommandeToDisplay() {
      return this.commandeAchatBailleur.lignesCommande.filter((ligne) => {
        return ligne.type === PERSONNALISE;
      });
    },
    getallOpen() {
      return this.allOpen;
    },
    calcul() {
      calculCommandeDevis(this.commandeAchatBailleur);
      if (this.modulePresseActive && !this.commandeAchatBailleur.regleFacturationId) {
        regleFacturationInitialize(this.commandeAchatBailleur);
      }
    },
  },
  provide() {
    return {
      allOpen: this.getallOpen,
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.regimeTva]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
      ]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
